/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Offerdetail_Media_Downloadcoveraria3Inputs */

const id_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unduh sampul ${i?.type}`)
};

const ms_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Muat turun kulit ${i?.type}`)
};

const da_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Download ${i?.type} cover`)
};

const de_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.type}-Cover herunterladen`)
};

const en_us2_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Download ${i?.type} cover`)
};

const es_es2_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descargar portada ${i?.type}`)
};

const es_mx2_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descargar portada ${i?.type}`)
};

const fil_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I-download ang ${i?.type} cover`)
};

const fr_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Télécharger la couverture ${i?.type}`)
};

const it_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scarica copertina ${i?.type}`)
};

const hu_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.type} borító letöltése`)
};

const nl_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.type} omslag downloaden`)
};

const no_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last ned ${i?.type}-forside`)
};

const pl_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pobierz okładkę ${i?.type}`)
};

const pt_br2_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Baixe a capa de ${i?.type}`)
};

const pt_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descarregar capa ${i?.type}`)
};

const ro_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descarcă copertă ${i?.type}`)
};

const fi_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lataa ${i?.type}-kansi`)
};

const sv_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ladda ner ${i?.type}-omslag`)
};

const vi_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tải xuống bìa ${i?.type}`)
};

const tr_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.type} kapağını indir`)
};

const cs_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stáhnout obálku ${i?.type}`)
};

const bg_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Изтегляне на ${i?.type} корица`)
};

const ru_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Скачать обложку ${i?.type}`)
};

const uk_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Завантажити обкладинку ${i?.type}`)
};

const ar_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تنزيل غلاف ${i?.type}`)
};

const hi_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.type} कवर डाउनलोड करें`)
};

const th_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ดาวน์โหลดปก ${i?.type}`)
};

const ja_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.type} カバーをダウンロード`)
};

const zh_cn2_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`下载 ${i?.type} 封面`)
};

const zh_hant1_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`下載 ${i?.type} 封面`)
};

const ko_offerdetail_media_downloadcoveraria3 = /** @type {(inputs: Offerdetail_Media_Downloadcoveraria3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.type} 커버 다운로드`)
};

/**
* | output |
* | --- |
* | "Download {type} cover" |
*
* @param {Offerdetail_Media_Downloadcoveraria3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_media_downloadcoveraria3 = /** @type {((inputs: Offerdetail_Media_Downloadcoveraria3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Media_Downloadcoveraria3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "ms") return ms_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "da") return da_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "de") return de_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "fil") return fil_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "fr") return fr_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "it") return it_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "hu") return hu_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "nl") return nl_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "no") return no_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "pl") return pl_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "pt") return pt_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "ro") return ro_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "fi") return fi_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "sv") return sv_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "vi") return vi_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "tr") return tr_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "cs") return cs_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "bg") return bg_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "ru") return ru_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "uk") return uk_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "ar") return ar_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "hi") return hi_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "th") return th_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "ja") return ja_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_media_downloadcoveraria3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_media_downloadcoveraria3(inputs)
	return ko_offerdetail_media_downloadcoveraria3(inputs)
});
export { offerdetail_media_downloadcoveraria3 as "offerDetail.media.downloadCoverAria" }